import React from 'react';
import { Col, Row } from 'reactstrap';
import { Carousel } from 'react-responsive-carousel';
import { useSelector } from 'react-redux';
import { tenantSelector } from '../../store/slices/tenantSlice';

const PreLoginLayoutRoute = (props) => {
    const { config } = useSelector(tenantSelector);
    const isWhiteLabeled = !!config;

    const items = [{
        image: 'login_tools',
        title: 'coGuide',
        content: 'Why multiple tools for research? Checkout coGuide. Integrate research suite for every researcher.'
    }, {
        image: 'login_sample_size',
        title: 'Sample size for research in easy steps',
        content: 'Sample size is the most vital part of your research. Get the most comprehensive sample size output without the need for any satisfaction'
    }, {
        image: 'login_data_entry',
        title: 'Pic & Drop to create a data entry template',
        content: 'Unique pic and drop functionality to create a customized mobile friendly electronic data entry template. Enter data as and when you recruit participants and collect data'
    }, {
        image: 'login_data_analysis',
        title: 'Real time data analysis',
        content: 'Unique pic and drop functionality to create a customized mobile friendly electronic data entry template. Enter data as and when you recruit participants and collect data'
    }, {
        image: 'login_wizards',
        title: 'Simple to use Wizard for critical elements ',
        content: 'Provide answers to simple questions about your research idea and witness the title & objectives f your research constructed n internationally recommended PICOST and SMART formats respectively'
    }]
    return (
        <>
            {window.innerWidth > 700 ?
                <Row className='pre-login-layout m-0'>
                    {!isWhiteLabeled && (
                        <Col className="col-lg-6 col-xs-12 p-0">
                            <div className='left-bg'>
                                <Carousel autoPlay={true} infiniteLoop={true} showStatus={false} showIndicators={false} interval={5000} showArrows={false} showThumbs={false}>
                                    {items.map((obj, index) => (
                                        <div key={index}>
                                            <img src={`${process.env.PUBLIC_URL}/images/${obj.image}.svg`} alt={obj.image} />
                                            <div className='carousel-title'>{obj.title}</div>
                                            <div className='carousel-content'>{obj.content}</div>
                                        </div>
                                    ))}
                                </Carousel>
                            </div>
                        </Col>
                    )}
                    <Col className={`${isWhiteLabeled ? 'col-12' : 'col-md-6'} col-xs-12 p-0`}>
                        <div className={`right-bg ${isWhiteLabeled ? 'tenant-right-bg' : ''}`}>
                            <div className='right-bg-content'>{props.children}</div>
                        </div>
                    </Col>
                </Row>
                :
                <div className='pre-login-layout'>
                    {!isWhiteLabeled && (
                        <div className='left-bg'>
                            <Carousel autoPlay={true} infiniteLoop={true} showStatus={false} showIndicators={false} interval={5000} showArrows={false} showThumbs={false}>
                                {items.map((obj, index) => (
                                    <div key={index}>
                                        <img className="image" src={`${process.env.PUBLIC_URL}/images/${obj.image}.svg`} alt={obj.image} />
                                    </div>
                                ))}
                            </Carousel>
                        </div>
                    )}
                    <div className={`right-bg ${isWhiteLabeled ? 'tenant-right-bg' : ''}`}>
                        <div className='right-bg-content'>{props.children}</div>
                    </div>
                </div>}
        </>
    )
};

export default PreLoginLayoutRoute;  